import vars from "../helpers";

export function intro() {
	let $intro = $('.intro');
	let card1 = $intro.find('.intro__card--1');
	let card2 = $intro.find('.intro__card--2');

	card1.on('click', () => {
		vars.scrollTo($('#section-1'), 1000 , 0)
	});

	card2.on('click', () => {
		vars.scrollTo($('#section-2'), 3000 , 0)
	});
}
